module.exports = __webpack_public_path__ + "img/dg-coupon.20ee9bf2.png";